import { LegalPageLayout } from '../components/LegalPageLayout';
import { LegalSection } from '../components/LegalSection';
import { PRIVACY_POLICY } from '../../application/constants/legalDocuments';

/**
 * Página de Aviso de Privacidad
 * Ruta: /legal/privacy
 */
export const PrivacyPolicy = () => {
  return (
    <LegalPageLayout
      effectiveDate={PRIVACY_POLICY.effectiveDate}
      title="Aviso de Privacidad"
      version={PRIVACY_POLICY.version}
    >
      {PRIVACY_POLICY.sections.map((section) => (
        <LegalSection content={section.content} key={section.id} title={section.title} />
      ))}
    </LegalPageLayout>
  );
};
